import {Box, Typography, useTheme} from '@mui/material';

import {getLogo} from '../../layouts/theme/Utils';

interface Props {
  title: string;
  subTitle?: string;
  paragraph?: string;
  button?: React.ReactNode;
}

export const FallbackMessage = ({title, subTitle, paragraph, button}: Props) => {
  const theme = useTheme();

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      sx={{
        mt: 5,
        backgroundColor: 'background.menu',
        borderRadius: 3,
        p: 4,
      }}
      gap={2}
    >
      <Box
        display={'flex'}
        sx={{
          justifyContent: {xs: 'center', md: 'left'},
        }}
      >
        <Box component={'img'} src={getLogo()} alt='Empion Logo' />
      </Box>

      <Typography variant='h1' textAlign={'center'}>
        {title}
      </Typography>

      {subTitle && (
        <Typography variant='h3' textAlign={'center'}>
          {subTitle}
        </Typography>
      )}

      {paragraph && (
        <Box
          sx={{
            p: 2,
            mt: 2,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            backgroundColor: theme.palette.action.hover,
            maxWidth: '80%',
            mx: 'auto',
          }}
        >
          <Typography
            variant='body1'
            textAlign={'center'}
            sx={{
              color: theme.palette.text.secondary,
            }}
          >
            {paragraph}
          </Typography>
        </Box>
      )}
      {button && button}
    </Box>
  );
};
